import React from 'react';
import ExperiencesWizard from './ExperiencesWizard';
import { useApp } from '../../../../hooks';
import { formatExperienceFormPayload } from '../Utilities/ExperienceHelpers';
import { ExperiencePricingTypeEnum } from '@koob/enums';
import { useAsync } from 'react-async';
import {
  getOrganization,
  getOrganizationCancelConditions,
} from 'api/node/organization';
import { decodeId } from 'utils';
import { formatCancellationPoliciesToForm } from 'components/Fields/CancelConditionField/utils';

export default function ExperienceForm({
  initialValues,
  handleSave,
  initialStep = 0,
  currentLocale,
  setCurrentLocale,
  isReadOnly = false,
}) {
  const { currentOrganizationIdInt, currentOrganizationId } = useApp();

  const { data: cancellationPoliciesData } = useAsync({
    promiseFn: getOrganizationCancelConditions,
    organizationId: decodeId(currentOrganizationId),
    skip: !!initialValues,
  });

  const { data: orga } = useAsync({
    promiseFn: getOrganization,
    id: decodeId(currentOrganizationId),
    filters: {
      locale: currentLocale?.value,
      withDetails: false,
    },
  });
  const organizationCancellationPolicies = orga?.data?.cancellationPolicies;

  const newInitialValues = initialValues ?? {
    durationDays: 0,
    durationHours: 0,
    durationMinutes: 0,
    state: 'in_progress',
    organizationId: '' + currentOrganizationIdInt,
    pictures: [],
    mediaLinks: [],
    guidingLanguages: [],
    pricingType: ExperiencePricingTypeEnum.FIT,
    extras: [],
    cancellationPolicies: organizationCancellationPolicies,
    isRepeatable: false,
    isTransitionalProgram: false,
    cancelConditions: formatCancellationPoliciesToForm(
      cancellationPoliciesData?.data,
    ),
  };

  return (
    <ExperiencesWizard
      initialExperience={newInitialValues}
      initialStep={initialStep}
      handleSave={(values) => {
        return formatExperienceFormPayload(values).then((payload) => {
          return handleSave(payload);
        });
      }}
      currentLocale={currentLocale}
      setCurrentLocale={setCurrentLocale}
      organization={orga?.data}
      isReadOnly={isReadOnly}
    />
  );
}
